import type { NozzleDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NozzleService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getAll = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, NozzleDto[]>({
      method: 'GET',
      url: '/api/app/nozzle',
    },
    { apiName: this.apiName,...config });
}